/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 判断是否是对象
 * @param value any
 * @returns boolean
 */
const isObject = (value: any) => {
  return value !== null && typeof value === 'object';
};

/**
 * 判断是否是function
 * @param value any
 * @returns boolean
 */
const isFunction = (value: any) => {
  return typeof value === 'function';
};

/**
 * 判断是否是Promise对象
 * @param value any
 * @returns boolean
 */
const isPromise = (value: any) => {
  return isObject(value) && isFunction(value.then) && isFunction(value.catch);
};

/**
 * 判断是否是Array
 */
const isArray = (value: any) => Array.isArray(value);

/**
 * 判断是否是String
 */
const isString = (value: any) => typeof value === 'string';

/**
 * 判断是否为数字
 * @param value
 * @returns
 */
const isNumber = (value) => {
  return /^-?\d+(\.\d+)?$/.test(value);
};

export { isObject, isFunction, isPromise, isArray, isString, isNumber };
